import { styled } from '@uhg-abyss/web/tools/styled';
import { PageSize } from '@uhg-abyss/web/ui/Pagination';

export const StyledPageSize = styled(PageSize, {
  dynamic: ({ cssProps: { isHidePageOptions } = {} }) => ({
    '.abyss-pagination-page-size-label': {
      display: isHidePageOptions ? 'none' : '',
      fontWeight: '600',
    },
    '.abyss-pagination-page-size-select-input': {
      display: isHidePageOptions ? 'none' : '',
      maxHeight: '100%',
    },
  }),
});

export const StyledPageSizeV2 = styled(PageSize, {
  dynamic: ({ cssProps: { isHidePageOptions } = {} }) => ({
    '.abyss-pagination-page-size-label': {
      display: isHidePageOptions ? 'none' : '',
      fontWeight: '600',
    },
    '.abyss-pagination-page-size-select-input': {
      display: isHidePageOptions ? 'none' : '',
      maxHeight: '100%',
    },
  }),
});

export const styledPaginationContainer = (
  expandedProviderListView: boolean
) => ({
  flexDirection: 'column',
  gap: expandedProviderListView ? '10px' : '0px',
  alignItems: 'center',
  '@media (max-width: 744px)': {
    display: 'flex',
    '.abyss-pagination-root': {
      border: 'none',
      borderBottom: 'none',
    },
    '.abyss-pagination-divider': {
      display: 'none',
    },
    '.abyss-pagination-abbreviated-container': {
      padding: '0px',
    },
    '.abyss-pagination-arrow': {
      border: 'none',
      padding: '9px 4px',
    },
  },
});
